import { render, staticRenderFns } from "./DialogModifyExamPeriod.vue?vue&type=template&id=18d7a3e4&scoped=true"
import script from "./DialogModifyExamPeriod.vue?vue&type=script&lang=js"
export * from "./DialogModifyExamPeriod.vue?vue&type=script&lang=js"
import style0 from "./DialogModifyExamPeriod.vue?vue&type=style&index=0&id=18d7a3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7a3e4",
  null
  
)

export default component.exports